"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneContainer = void 0;

var _designLanguage = require("@doordash/design-language");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PhoneContainer = (0, _styledComponents["default"])(_designLanguage.InlineChildren).attrs({
  size: _designLanguage.InlineChildren.Sizes.XxSmall
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & > *:first-child {\n    flex-shrink: 2;\n    min-width: 128px;\n  }\n  & > *:last-child {\n    flex-grow: 1;\n    flex-shrink: 1;\n  }\n"])));
exports.PhoneContainer = PhoneContainer;